import { Container } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { PaymentEvents_paymentEvents_edges_node } from "@saleor/paymentEvents/types/PaymentEvents";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { PaymentEventsList } from "../PaymentEventsList";
import {
  createFilterStructure,
  PaymentEventsFilterKeys,
  PaymentEventsListFilterOpts
} from "./filters";

export interface PaymentEventsListPageProps
  extends ListProps,
    FilterPageProps<PaymentEventsFilterKeys, PaymentEventsListFilterOpts>,
    TabPageProps {
  paymentEvents: PaymentEvents_paymentEvents_edges_node[];
  onView: (api: string, id: string) => void;
}

export const PaymentEventsListPage: React.FC<PaymentEventsListPageProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  paymentEvents,
  currencySymbol,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <Container>
      <PageHeader
        title={intl.formatMessage(sectionNames.paymentEvents)}
      ></PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Reference"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <PaymentEventsList paymentEvents={paymentEvents} {...listProps} />
      </Card>
    </Container>
  );
};

export default PaymentEventsListPage;
